module.exports = __webpack_public_path__ + "media/images/single-pattern-3515b65489d9889aef84264cc46674d8.svg";